import type { ControlIdentity, FeaturePermission } from '../../api/model/models';

export const mockControlIdentity: ControlIdentity = {
  featureName: 'localizedNameSingular',
  entityUid: 'typeDefinition/kgd9rvwdcy7qqus6w5w3mtag3',
};

export const mockControlStateSharedData = {
  label: 'Label',
  alert: 'I am a helper text',
  validationMessage: 'I am a validation message',
  isRequired: false,
  readonly: false,
};

export const mockControlPermission: FeaturePermission = {
  mayEdit: true,
  featureName: mockControlIdentity.featureName,
};

export const mockControlsMisc = {
  validationSeverity: 'info',
  labelPosition: 'top',
};
